export default "__VITE_ASSET__DPmXAPts__"